import{HeroModule}from'./HeroModule';export default HeroModule;
//# sourceMappingURL=index.js.map